import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    radioAnatomy.keys
);

const baseStyle = definePartsStyle({
    control: {
        color: 'primary.400',
        _checked: {
            color: 'white',
            borderColor: 'primary.400',
            bg: 'primary.400',
            _hover: {
                bg: 'primary.500',
                borderColor: 'primary.500'
            }
        }
    }
});

export const radioTheme = defineMultiStyleConfig({ baseStyle });
